import { merge } from '@/helpers/Utility';
import { FC, useCallback, useState } from 'react';
import { FiChevronDown, FiChevronUp, FiClipboard } from 'react-icons/fi';
import strings from '../roster/roster.translations';
import { TemplateTaskButtons } from './TemplateTaskButtons';

export const TemplateTaskDrawer: FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleTasks = useCallback(() => {
    setDrawerOpen(current => !current);
  }, []);

  return (
    <div className="border-t bg-white">
      <div className="flex justify-between items-center border-b px-5 py-2">
        <button
          onClick={toggleTasks}
          className={merge(
            'text-xl py-1 px-5 flex gap-2 items-center rounded-full border border-2 font-semibold',
            drawerOpen ? 'bg-primary-100 text-primary-500 border-primary-500' : 'bg-white text-gray-700 border-gray-700'
          )}
        >
          <FiClipboard className="h-6 w-6" />
          {strings.drawer.tasks.label}
        </button>
        <button onClick={toggleTasks}>
          {drawerOpen ? <FiChevronDown className="h-10 w-10" /> : <FiChevronUp className="h-10 w-10" />}
        </button>
      </div>
      {drawerOpen && (
        <div className="h-40 py-2 px-5 overflow-auto">
          <TemplateTaskButtons />
        </div>
      )}
    </div>
  );
};
